import React, { useEffect, useState } from "react";
import TeamsCollectionView from "../../components/teams/TeamsCollectionView";
import { Busy } from "../../components/Busy";
import { usePublicStore } from "../../store/publicStore";
import { Heading } from "../../components/catalyst/heading";
import MainPageLayout from "../../components/layouts/MainPageLayout";
import { Footer } from "../landing/Footer";
import { ChevronDown, ChevronUp } from "lucide-react";

const Teams: React.FC<any> = () => {
  const { isBusy, allGroupedTeams: allTeams, getCurrentSeason, getAllGroupedTeams } =
    usePublicStore();
  const [viewState, setViewState] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    getCurrentSeason();
    getAllGroupedTeams();
  }, []);

  const toggleExpansion = (id: string) => {
    setViewState((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  return (
    <MainPageLayout Footer={<Footer />}>
      <>
        <div className="py-3 px-2 pb-6">
          {allTeams && allTeams.length > 0 && (
            <>
              {allTeams
                .sort((a: any, b: any) => a.name.localeCompare(b.name))
                .map((grp: any) => (
                  <div key={grp.id}>
                    <div className="flex flex-row flex-wrap gap-2 items-center mt-4 bg-emerald-800 rounded-sm px-2 cursor-pointer"
                          onClick={() => toggleExpansion(grp.id)}
                          >
                      <Heading className="text-gray-200!">{grp.name}</Heading>
                      <div className="ml-auto">
                        <ChevronDown
                          className={`cursor-pointer text-white ${
                            viewState[grp.id] ? "hidden" : "block"
                          }`}
                          onClick={() => toggleExpansion(grp.id)}
                        />
                        <ChevronUp
                          className={`cursor-pointer text-white ${
                            viewState[grp.id] ? "block" : "hidden"
                          }`}
                          onClick={() => toggleExpansion(grp.id)}
                        />
                      </div>
                    </div>
                    <TeamsCollectionView
                      showSearch={false}
                      teams={grp.teams}
                      setSearch={() => {}}
                      searchText={""}
                      showMembers={viewState[grp.id] || false}
                    />
                  </div>
                ))}
            </>
          )}
          {(!allTeams || allTeams.length === 0) && (
            <div className="text-center">No teams available</div>
          )}

        </div>
        {isBusy && <Busy busyMessage={"Please wait..."} />}
      </>
    </MainPageLayout>
  );
};

export default Teams;
